import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-camping",
  "use": "icon-camping-usage",
  "viewBox": "0 0 48 48",
  "content": "<symbol viewBox=\"0 0 48 48\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-camping\"><path d=\"M5.00006 43.5V35.1193L22.6116 11.3386L19.8386 7.62707L21.6924 6.30017L24 9.45397L26.3577 6.30017L28.1615 7.62707L25.4385 11.3386L43 35.1193V43.5H5.00006ZM24 13.2731L7.26926 35.8693V41.2308H14.4423L24 27.8501L33.5769 41.2308H40.7308V35.8693L24 13.2731ZM17.2384 41.2308H30.7616L24 31.75L17.2384 41.2308Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol